import { render, staticRenderFns } from "./calc-bottom.vue?vue&type=template&id=7bca9afe&scoped=true"
import script from "./calc-bottom.vue?vue&type=script&lang=ts"
export * from "./calc-bottom.vue?vue&type=script&lang=ts"
import style0 from "./calc-bottom.vue?vue&type=style&index=0&id=7bca9afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bca9afe",
  null
  
)

export default component.exports